export function byKeyOrId(o1, o2) {
	return (o1._key && o1._key === o2._key) || (o1.id && o1.id === o2.id);
}

export function byFinalidadeIdentificacao(foto) {
	return foto.finalidade === "IDENTIFICACAO";
}
